//指定されたシートにリンクしているカードまたは矢印が存在するシートのIDを配列で返す
import { useSelector } from 'react-redux';
import { RootState } from '../redux/rootReducer';
import * as Linq from 'linq';

const useSheetIdsForLink = (sheetId?: string | null): string[] => {
  const cardDb = useSelector((state: RootState) => state.cardDb);
  const arrowDb = useSelector((state: RootState) => state.arrowDb);
  const sheetIds: string[] = [];

  if(sheetId) {
    //指定シートにリンクを貼っているカードが存在する、シートのIDを取得
    const card_ids = Object.keys(cardDb.cards).filter(id => {
      const card = cardDb.cards[id];
      const linkedSheetIds: string[] = [];
      card.links?.map((sheet_id) => {
        if(sheet_id === sheetId) linkedSheetIds.push(sheet_id);
      });
      return linkedSheetIds.length > 0;
    });
    card_ids.forEach(card_id => {
      sheetIds.push(cardDb.cards[card_id].sheetId);
    });

    //指定シートにリンクを貼っている矢印が存在する、シートのIDを取得
    const arrow_ids = Object.keys(arrowDb.arrows).filter(id => {
      const arrow = arrowDb.arrows[id];
      const linkedSheetIds: string[] = [];
      arrow.links?.map((sheet_id) => {
        if(sheet_id === sheetId) linkedSheetIds.push(sheet_id);
      });
      return linkedSheetIds.length > 0;
    });
    arrow_ids.forEach(arrow_id => {
      sheetIds.push(arrowDb.arrows[arrow_id].sheetId);
    });
  }

  //重複しているIDを除く
  let rtn_sheetIds = Linq.from(sheetIds).distinct().toArray();
  
  return rtn_sheetIds;
}

export default useSheetIdsForLink;